module.exports = __webpack_public_path__ + "img/craig-mullins-ck3-duel.4c1a7a52.webp";